"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceAdapterStarknetContractAdapter = void 0;
const StarknetContractConnector_1 = require("../StarknetContractConnector");
const starknet_utils_1 = require("../starknet-utils");
class PriceAdapterStarknetContractAdapter {
    contract;
    constructor(contract) {
        this.contract = contract;
    }
    async writePricesFromPayloadToContract(paramsProvider) {
        return (await this.contract.invoke("write_prices", [
            paramsProvider.getHexlifiedFeedIds(),
            await paramsProvider.getPayloadData(),
        ], { maxFee: 0.004 * StarknetContractConnector_1.FEE_MULTIPLIER, parseRequest: true })).transaction_hash;
    }
    async getPricesFromPayload(paramsProvider) {
        return (0, starknet_utils_1.extractNumbers)(await this.contract.call("get_prices", [
            paramsProvider.getHexlifiedFeedIds(),
            await paramsProvider.getPayloadData(),
        ]));
    }
    async readPricesFromContract(paramsProvider) {
        return (0, starknet_utils_1.extractNumbers)(await this.contract.call("read_prices", [
            paramsProvider.getHexlifiedFeedIds(),
        ]));
    }
    async readTimestampFromContract() {
        return (0, starknet_utils_1.getNumberFromStarknetResult)(await this.contract.call("read_timestamp"));
    }
}
exports.PriceAdapterStarknetContractAdapter = PriceAdapterStarknetContractAdapter;
//# sourceMappingURL=PriceAdapterStarknetContractAdapter.js.map